<div class="col empty-container">
    <mat-icon>
        {{ icon }}
    </mat-icon>
    <span>{{ description }}</span>
    <ng-content></ng-content>
</div>